<template>
  <p v-if="text" class="tw-text-xs">
    {{ text }}
  </p>
</template>

<script>
import { toRefs, computed } from 'vue'

export default {
  props: {
    count: {
      type: Number,
      default: 0,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    const { count } = toRefs(props)

    function plural(count) {
      return count === 1 ? '' : 's'
    }

    const text = computed(() => {
      if (props.min > 0 && count.value < props.min) {
        const req = props.min - count.value
        return `${req} more character${plural(req)} required.`
      } else if (props.max > 0) {
        if (count.value > props.max) {
          return `Too many characters. (${count.value}/${props.max})`
        } else {
          const rem = props.max - count.value
          return `${rem} character${plural(rem)} remaining.`
        }
      }

      return ''
    })

    return {
      text,
    }
  },
}
</script>
